/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "channelEntityDefs",
    graphQL: "ChannelEntityDef",
    name: "Channel Entity Mapping",
    defaultOrder: ['sourceDef_id', 'entityDef_id'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'channelEntityDefs',
    defaultTitle: (data) => {
        return data['entityDef'] && data['entityDef']['name'];
    },
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Channel Entity ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        sourceDef: {
            name: "Source Definition",
            to: () => types['sourceDefs'],
            type: "relation",
            required: true,
            relativeTo: ['channelDef'],
        },
        entityDef: {
            name: "Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            required: true,
        },
        primaryFieldEntityDef: {
            name: "Primary Field Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
        },
        primaryFieldDef: {
            name: "Primary Field",
            to: () => types['fieldDefs'],
            type: "relation",
            relativeTo: ["primaryFieldEntityDef"]
        },
        primary: {
            name: "Primary",
            type: "boolean",
            defaultValue: true,
        },
        afterMapperJavaScript: {
            name: "After Mapper JavaScript",
            type: "javascript",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
            globalVariables: {
                'options': 'options: Map',
                'channel': 'channel: Channel',
                'channelDef': 'channelDef: ChannelDef',
                'transmission': 'transmission: Transmission',
            },
        },
        devNote: {
            name: "Developer Note",
            type: "string",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        channelFieldDefs: {
            type: 'oneToMany',
            export: true,
            to: types['channelFieldDefs'],
            defaultValue: () => {
                return {};
            },
        },
        usedChannelFieldDefs: {
            type: 'oneToMany',
            export: false,
            to: types['channelFieldDefs'],
            controllerFn: 'getUsedChannelFieldDefIds',
        },
        usedFieldDefs: {
            type: 'handler',
            export: false,
            controllerFn: 'getUsedFieldDefIds',
            to: types['fieldDefs'],
        },
        channelRelationDefs: {
            type: 'handler',
            to: types['channelRelationDefs'],
            export: false,
            import: false,
            controllerFn: 'getRelatedChannelRelationDefs',
        },
    }; }
});
